// src/shared/service/api/vendorSeasonListApiService.ts
import axios from 'axios';
import {
  BASE_URL,
  VENDOR_SEASON_LIST_API_PATH,
  VENDOR_SEASON_LIST_BULK_BY_SEASON_SUB_PATH,
  VENDOR_SEASON_LIST_BULK_SUB_PATH,
} from '../../../constants/api';
import { FetchResult } from '../../type/apiType';
import {
  VendorSeasonListBulkBySeasonRequest,
  VendorSeasonListBulkCreateRequest,
  VendorSeasonListBulkCreateResponse,
  VendorSeasonListCreateRequest,
  VendorSeasonListPatchRequest,
  VendorSeasonListQueryParams,
  VendorSeasonListRow,
} from '../../type/vendorSeasonListType';
import { ApiService } from './apiService';

const stripLeadingSlash = (s: string): string => (s.startsWith('/') ? s.slice(1) : s);

class VendorSeasonListApiService extends ApiService<VendorSeasonListRow> {
  constructor() {
    super(VENDOR_SEASON_LIST_API_PATH);
  }

  public async fetchList(
    params?: VendorSeasonListQueryParams
  ): Promise<FetchResult<VendorSeasonListRow>> {
    const response = await axios.get(`${BASE_URL}${VENDOR_SEASON_LIST_API_PATH}`, { params });
    return response.data;
  }

  public async createMapping(body: VendorSeasonListCreateRequest): Promise<VendorSeasonListRow> {
    const response = await axios.post(`${BASE_URL}${VENDOR_SEASON_LIST_API_PATH}`, body);
    return response.data;
  }

  public async bulkCreateMappings(
    body: VendorSeasonListBulkCreateRequest
  ): Promise<VendorSeasonListBulkCreateResponse> {
    const response = await axios.post(
      `${BASE_URL}${VENDOR_SEASON_LIST_API_PATH}${stripLeadingSlash(VENDOR_SEASON_LIST_BULK_SUB_PATH)}`,
      body
    );
    return response.data;
  }

  /**
   * 특정 시즌에 여러 user를 한 번에 매핑.
   */
  public async bulkCreateBySeason(
    body: VendorSeasonListBulkBySeasonRequest
  ): Promise<VendorSeasonListBulkCreateResponse> {
    const response = await axios.post(
      `${BASE_URL}${VENDOR_SEASON_LIST_API_PATH}${stripLeadingSlash(
        VENDOR_SEASON_LIST_BULK_BY_SEASON_SUB_PATH
      )}`,
      body
    );
    return response.data;
  }

  public async patchMapping(
    id: number,
    body: VendorSeasonListPatchRequest
  ): Promise<VendorSeasonListRow> {
    const response = await axios.patch(`${BASE_URL}${VENDOR_SEASON_LIST_API_PATH}${id}/`, body);
    return response.data;
  }

  public async deleteMapping(id: number): Promise<void> {
    await axios.delete(`${BASE_URL}${VENDOR_SEASON_LIST_API_PATH}${id}/`);
  }
}

export const vendorSeasonListApiService = new VendorSeasonListApiService();
